<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/league")
          i.fa.fa-trophy
          span.ml-1 {{ $tc("ui.leagues", 1) }}
      b-breadcrumb-item
        router-link(to="/list/mapleague")
          i.fa.fa-link
          span.ml-1 {{ $t("ui.map_league") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-basketball-ball
                    b-form-select(v-model="sportType" autofocus)
                      //- option(value=0)
                      //-   | {{ $t("ui.all") }}
                      option(v-for="sportInfo in sportList" v-bind:value="sportInfo.sport_id")
                        | {{ sportInfo.sport_type }}
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-link
                    b-form-select(v-model="mapped" @change="changeMap")
                      option(value="false") {{ $t('ui.not_mapped') }}
                      option(value="true") {{ $t('ui.mapped') }}
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-search
                    DebounceInput(required ref="league_name" type="text" v-model="leagueName" :placeholder="$t('message.search_by_league_name')").mr-2
                //- div.col-md-3.mb-1
                //-   b-input-group(size="sm")
                //-     b-input-group-text(slot="prepend")
                //-       i.fas.fa-sort
                //-     b-form-select(v-model="firstSortKey")
                //-       option(value="league_id") {{ $t('ui.id') }}
                //-       option(value="sport_type") {{ $tc('ui.sports', 1) }}
                //-       option(value="league_name") {{ $tc("ui.leagues", 1) }}
                //-     b-form-select(v-model="firstSortType")
                //-       option(value="asc") {{ $t("ui.ascending") }}
                //-       option(value="desc") {{ $t("ui.descending") }}
                div.col-md-4.mb-1
                  sync.mb-1.mr-2(@clicked="getLeagueList()")
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getLeagueList()"
                    variant="success"
                    size="sm"
                    ).mb-1.mr-2
                  //- SubmitButton(
                  //-   :loading="loading"
                  //-   icon="fa fa-unlink"
                  //-   :text="$t('ui.unmap')"
                  //-   type="button"
                  //-   @click="unmapLeague()"
                  //-   variant="secondary"
                  //-   size="sm"
                  //-   v-if="firstLeagueIdSelected!='' && secondLeagueIdSelected !='' && curMappedValue == 'true'"
                  //- ).mb-1.mr-2
        div.card-body
          div.row.mb-5
            // SBO
            div.col-6
              div.row.mb-2
                div.col-3
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-sitemap
                    b-input(:value="firstProvider" readonly)
                    b-input(:value="filterFirstLeagueListLength" readonly)
                div.col-7
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-search
                    DebounceInput(required type="text" v-model="firstLeagueSearch" :placeholder="$t('message.search_by_team_name')").mr-2
                    b-form-radio-group(
                      buttons
                      v-model="leagueFilterBy"
                      size="sm"
                      button-variant="outline-info"
                    )
                      b-form-radio(value="id") {{ $t("ui.id") }}
                      b-form-radio(value="name") {{ $t("ui.name") }}
                div.col-2.text-right
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-link"
                    :text="$t('ui.sbo_prefer')"
                    type="button"
                    @click="mapLeague('first')"
                    variant="secondary"
                    size="sm"
                    v-if="firstLeagueIdSelected!='' && secondLeagueIdSelected !='' && curMappedValue == 'false'"
                  )
              div.row.mb-1
                div.col-12.clusterize
                  div#tblFirstLeague.clusterize-scroll(style="overflow-x: hidden !important;")
                    table.tablex(v-columns-resizable)
                      thead
                        tr
                          th.sticky-position(width=100 @click="sortOrder('league_id', 'first')")
                            span {{ $t('ui.id') }}
                            i(:class="changeSortKey('league_id', 'first')")
                          th.sticky-position(width=100 @click="sortOrder('sport_type', 'first')")
                            span {{ $tc('ui.sports', 1) }}
                            i(:class="changeSortKey('sport_type', 'first')")
                          th.sticky-position(@click="sortOrder('league_name', 'first')")
                            span {{ $t('ui.name') }}
                            i(:class="changeSortKey('league_name', 'first')")
                      tbody.clusterize-content
                        tr(
                          v-for="(firstLeagueInfo, index) in filterFirstLeagueList"
                          @click="rowSelect(firstLeagueInfo, 'firstLeague')"
                          :class="{ 'selectedRow' : selectedRow(firstLeagueInfo, 'firstLeague') }"
                          :ref="firstLeagueInfo.league_id"
                          :key="index"
                          )
                          td
                            span {{ firstLeagueInfo.league_id }}
                          td
                            span {{ firstLeagueInfo.sport_type }}
                          td
                            span(:title="firstLeagueInfo.league_name") {{ firstLeagueInfo.league_name }}
            // IBC / CMD
            div.col-6
              div.row.mb-2
                div.col-3
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-sitemap
                    b-form-select(v-model="secondProvider")
                      option(value="IBC") {{ $t('ui.ibc') }}
                      //- option(value="CMD" disabled) {{ $t('ui.cmd') }}
                    b-input(:value="filterSecondLeagueListLength" readonly)
                div.col-7
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-search
                    DebounceInput(required type="text" v-model="secondLeagueSearch" :placeholder="$t('message.search_by_team_name')").mr-2
                    b-form-radio-group(
                      buttons
                      v-model="leagueFilterBy"
                      size="sm"
                      button-variant="outline-info"
                    )
                      b-form-radio(value="id") {{ $t("ui.id") }}
                      b-form-radio(value="name") {{ $t("ui.name") }}
                div.col-2.text-right
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-link"
                    :text="$t('ui.ibc_prefer')"
                    type="button"
                    @click="mapLeague('second')"
                    variant="secondary"
                    size="sm"
                    v-if="firstLeagueIdSelected!='' && secondLeagueIdSelected !='' && curMappedValue == 'false'"
                  )
              div.row.mb-1
                div.col-12.clusterize
                  div.clusterize-scroll#tblSecondLeague(style="overflow-x: hidden !important;")
                    table.tablex(v-columns-resizable)
                      thead
                        tr
                          th.sticky-position(width=100 @click="sortOrder('league_id', 'second')")
                            span {{ $t('ui.id') }}
                            i(:class="changeSortKey('league_id', 'second')")
                          th.sticky-position(width=100 @click="sortOrder('sport_type', 'second')")
                            span {{ $tc('ui.sports', 1) }}
                            i(:class="changeSortKey('sport_type', 'second')")
                          th.sticky-position(@click="sortOrder('league_name', 'second')")
                            span {{ $t('ui.name') }}
                            i(:class="changeSortKey('league_name', 'second')")
                      tbody.clusterize-content
                        tr(
                          v-for="(secondLeagueInfo, index) in filterSecondLeagueList"
                          @click="rowSelect(secondLeagueInfo, 'secondLeague')"
                          :class="{ 'selectedRow' : selectedRow(secondLeagueInfo, 'secondLeague') }"
                          :ref="secondLeagueInfo.league_id"
                          )
                          td
                            span {{ secondLeagueInfo.league_id }}
                          td
                            span {{ secondLeagueInfo.sport_type }}
                          td
                            span(:title="secondLeagueInfo.league_name") {{ secondLeagueInfo.league_name }}
</template>
<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import VueScrollTo from "vue-scrollto";
import stringSimilarity from "string-similarity";
import sync from "@/components/sync.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    VueScrollTo,
    sync
  },
  data: () => ({
    loading: false,
    sportType: 1,
    sportList: [],
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    firstLeagueList: [],
    secondLeagueList: [],
    firstProvider: "SBO",
    secondProvider: "IBC",
    curMappedValue: "",
    mapped: "false",
    firstLeagueIdSelected: "",
    secondLeagueIdSelected: "",
    leagueFilterBy: "name",
    firstSortKey: "league_name",
    firstSortType: "asc",
    secondSortKey: "league_name",
    secondSortType: "asc",
    fls: "",
    sls: "",
    leagueName: "",
  }),
  computed: {
    filterFirstLeagueListLength() {
      if (this.filterFirstLeagueList) {
        return this.filterFirstLeagueList.length;
      } else {
        return 0;
      }
    },
    filterFirstLeagueList() {
      return this.firstLeagueList.filter(item => {
        if (this.leagueFilterBy == 'name')
          return item.league_name.toLowerCase().indexOf(this.firstLeagueSearch.toLowerCase()) > -1;
        else if (this.leagueFilterBy == 'id')
          return item.league_id.toString().toLowerCase().indexOf(this.firstLeagueSearch.toLowerCase()) > -1;
      })
      .sort((a, b) => {
        if (this.firstSortType == 'asc')
          return a[this.firstSortKey] > b[this.firstSortKey] ? 1 : -1;
        else
          return a[this.firstSortKey] < b[this.firstSortKey] ? 1 : -1;
      });
    },
    filterSecondLeagueListLength() {
      if (this.filterSecondLeagueList) {
        return this.filterSecondLeagueList.length;
      } else {
        return 0;
      }
    },
    firstLeagueSearch:
    {
      get() {
        return this.fls;
      },
      set(value) {
        this.fls = value;
        this.sls = value;
      }
    },
    secondLeagueSearch:
    {
      get() {
        return this.sls;
      },
      set(value) {
        this.sls = value;
      }
    },
    filterSecondLeagueList() {
      this.secondLeagueSearch

      return this.secondLeagueList.filter(item => {
        if (this.leagueFilterBy == 'name')
          return item.league_name.toLowerCase().indexOf(this.secondLeagueSearch.toLowerCase()) > -1;
        else if (this.leagueFilterBy == 'id')
          return item.league_id.toString().toLowerCase().indexOf(this.secondLeagueSearch.toLowerCase()) > -1;
      })
      .sort((a, b) => {
        if (this.secondSortType == 'asc')
          return a[this.secondSortKey] > b[this.secondSortKey] ? 1 : -1;
        else
          return a[this.secondSortKey] < b[this.secondSortKey] ? 1 : -1;
      });
    }
  },
  beforeDestroy() {
    this.sportList = [];
    this.firstLeagueList = [];
    this.secondLeagueList = [];
  },
  mounted: function() {
    this.getSportList();
  },
  methods: {
    sortOrder(key, type) {
      if (type == 'first') {
        if (this.firstSortKey == key)
          this.firstSortType = this.firstSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.firstSortKey = key;
          this.firstSortType = 'asc';
        }
      } else if (type == 'second') {
        if (this.secondSortKey == key)
          this.secondSortType = this.secondSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.secondSortKey = key;
          this.secondSortType = 'asc';
        }
      }

    },
    changeSortKey(key, type) {
      if (type == 'first') {
        if (this.firstSortKey != key)
          return 'fas fa-sort';
        else if (this.firstSortKey == key && this.firstSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.firstSortKey == key && this.firstSortType == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'second') {
        if (this.secondSortKey != key)
          return 'fas fa-sort';
        else if (this.secondSortKey == key && this.secondSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.secondSortKey == key && this.secondSortType == 'desc')
          return 'fa fa-sort-down';
      }
    },
    changeMap: function() {
      this.getLeagueList();
    },
    showTooltip: function(e) {
      if (e.srcElement.offsetWidth < e.srcElement.scrollWidth) {
        e.srcElement.title = e.srcElement.innerText;
      }
    },
    getSportList: function() {
      let url = config.sportListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.mapleague
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.sportList = [];
                this.sportList = response.data.tbl_sport_list;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    checkSearchCriteria: function () {
      if (this.leagueName.trim().length < 2) {
        return false;
      }

      return true;
    },
    getLeagueList: function() {
      if (this.checkSearchCriteria()) {
        this.reset();

        this.curMappedValue = this.mapped;

        let url = config.mapLeagueListUrl();

        var json = {
          action_by: this.$store.getters.username,
          session_token: this.$store.getters.sessionToken,
          page_id: config.accessRoles.mapleague,
          sport_id: this.sportType,
          mapped: this.mapped,
          map_from: this.firstProvider.toLowerCase(),
          map_to: this.secondProvider.toLowerCase(),
          league_name: this.leagueName.trim(),
          sort_key: this.firstSortKey,
          sort_type: this.firstSortType
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            // Success
            this.loading = false;
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.firstLeagueList = [];
                  this.secondLeagueList = [];
                  this.firstLeagueList = response.data.tbl_map_league_list.Table;
                  this.secondLeagueList = response.data.tbl_map_league_list.Table1;
                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            // Error
            this.loading = false;
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.firstLeagueList = [];
        this.secondLeagueList = [];
        this.$refs.league_name.$el.focus();
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.leagueNameMinTwoChar"), "error");
      }
    },
    selectedRow: function(info, type) {
      if (type == "firstLeague") {
        if (this.firstLeagueIdSelected == info.league_id) return true;
      } else if (type == "secondLeague") {
        if (this.secondLeagueIdSelected == info.league_id) return true;
      }

      return false;
    },
    rowSelect: function(leagueInfo, type) {
      // Find similarity from second panel
      // const test = this.secondLeagueList.map(item => {
      //   return item.league_name;
      // });

      if (this.curMappedValue == "true") {
        this.firstLeagueIdSelected = leagueInfo.sbo_map;

        if (this.secondProvider.toLowerCase() == "ibc") this.secondLeagueIdSelected = leagueInfo.ibc_map;
        else if (this.secondProvider.toLowerCase() == "cmd") this.secondLeagueIdSelected = leagueInfo.cmd_map;

        var VueScrollTo = require("vue-scrollto");

        var options = {
          container: type == "firstLeague" ? "#tblSecondLeague" : "#tblFirstLeague",
          offset: -250
        };

        var elem = type == "firstLeague" ? this.$refs[this.secondLeagueIdSelected][0] : this.$refs[this.firstLeagueIdSelected][0];

        VueScrollTo.scrollTo(elem, "500", options);
      } else {
        if (type == "firstLeague") {
          setTimeout(() => {
            this.firstLeagueIdSelected = leagueInfo.league_id;
          }, 10);
        } else if (type == "secondLeague") {
          setTimeout(() => {
            this.secondLeagueIdSelected = leagueInfo.league_id;
          }, 10);
        }
      }
    },
    mapLeague: function(type) {
      this.$helpers
        .alert({
          title: this.$t("ui.combine.map_league"),
          text: this.$t("message.map_league_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmMapLeague(type);
          }
        });
    },
    confirmMapLeague: function(type) {
      let url = "";

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.mapleague
      };

      if (this.firstProvider.toLowerCase() == "sbo" && this.secondProvider.toLowerCase() == "ibc") {
        url = config.mapLeagueSBOIBCUrl();
        json.sbo_id = this.firstLeagueIdSelected;
        json.ibc_id = this.secondLeagueIdSelected;
        json.prefer_id = type != 'first' ? this.secondLeagueIdSelected : this.firstLeagueIdSelected;
        json.prefer_provider = type != 'first' ? 'IBC' : 'SBO';
      } else if (this.firstProvider.toLowerCase() == "sbo" && this.secondProvider.toLowerCase() == "cmd") {
        url = config.mapLeagueSBOCMDUrl();
        json.sbo_id = this.firstLeagueIdSelected;
        json.cmd_id = this.secondLeagueIdSelected;
        json.prefer_id = type != 'first' ? this.secondLeagueIdSelected : this.firstLeagueIdSelected;
        json.prefer_provider = type != 'first' ? 'IBC' : 'SBO';
      }

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.removeLeagueFromList();
                // this.$helpers.showDialog(this.$t("ui.combine.map_league"), this.$t("message.success"), "success");
                this.$snotify.success(this.$t("message.success"));
              } else {
                this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    unmapLeague: function() {
      let url = "";

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.mapleague
      };

      if (this.firstProvider.toLowerCase() == "sbo" && this.secondProvider.toLowerCase() == "ibc") {
        url = config.unmapLeagueSBOIBCUrl();
        json.sbo_id = this.firstLeagueIdSelected;
        json.ibc_id = this.secondLeagueIdSelected;
      } else if (this.firstProvider.toLowerCase() == "sbo" && this.secondProvider.toLowerCase() == "cmd") {
        url = config.unmapLeagueSBOCMDUrl();
        json.sbo_id = this.firstLeagueIdSelected;
        json.cmd_id = this.secondLeagueIdSelected;
      }

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.removeLeagueFromList();
                // this.$helpers.showDialog(this.$t("ui.combine.unmap_league"), this.$t("message.success"), "success");
                this.$snotify.success(this.$t("message.success"));
              } else {
                this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    removeLeagueFromList: function() {
      let i = this.firstLeagueList
        .map(flInfo => {
          return flInfo.league_id;
        })
        .indexOf(this.firstLeagueIdSelected);
      this.firstLeagueList.splice(i, 1);

      let j = this.secondLeagueList
        .map(slInfo => {
          return slInfo.league_id;
        })
        .indexOf(this.secondLeagueIdSelected);
      this.secondLeagueList.splice(j, 1);

      this.firstLeagueIdSelected = "";
      this.secondLeagueIdSelected = "";
    },
    reset: function() {
      this.firstLeagueIdSelected = "";
      this.secondLeagueIdSelected = "";
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
tr,
td {
  cursor: pointer;
}
</style>